import { format } from 'date-fns'

import type { ReceiptSummary } from '@/api/types/receipt'
import { Badge } from '@/components/ui/badge'
import { parseUtcDate } from '@/lib/date-utils'
import { cn } from '@/lib/utils'

import { formatAmount } from '../field-value'

type Props = {
  receipt: ReceiptSummary
  isSelected: boolean
  onSelect: (receiptId: number) => void
}

const formatPurchasedAt = (iso: string | null): string => {
  if (!iso) return '日時不明'
  return format(parseUtcDate(iso), 'yyyy/MM/dd HH:mm')
}

export const ReceiptRow = ({ receipt, isSelected, onSelect }: Props) => {
  return (
    <button
      type="button"
      onClick={() => onSelect(receipt.id)}
      aria-current={isSelected}
      className={cn(
        'w-full rounded border border-gray-700 p-3 text-left transition-colors',
        isSelected ? 'border-primary bg-primary/10' : 'hover:bg-white/5',
      )}
    >
      <div className="flex items-baseline justify-between gap-2">
        <span className="truncate">{receipt.store_name || '店名なし'}</span>
        <span className="shrink-0 tabular-nums">{formatAmount(receipt.total_amount)}</span>
      </div>
      <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
        <span>{formatPurchasedAt(receipt.purchased_at)}</span>
        <span>{receipt.item_count}点</span>
        {receipt.place_id === null && <Badge variant="outline">場所未確定</Badge>}
        {receipt.error_count > 0 && <Badge variant="destructive">検算エラー {receipt.error_count}</Badge>}
        {receipt.critical_diff_count > 0 && <Badge variant="secondary">AI不一致 {receipt.critical_diff_count}</Badge>}
      </div>
    </button>
  )
}
